import React from 'react';
import { Box } from '@chakra-ui/react';

export default function SectionCard({ children, ...props }) {
  return (
    <Box
      bg="white"
      borderRadius="xl"
      boxShadow="sm"
      borderWidth="1px"
      borderColor="gray.200"
      p={{ base: 4, md: 6 }}
      {...props}
    >
      {children}
    </Box>
  );
}


